import { FormFieldType } from '@/shared/types/enum';

export const FormFieldTypesWithOptions: FormFieldType[] = [FormFieldType.Dropdown];

export type FormField = {
  name: string;
  label: string;
  type: FormFieldType;
  options?: string[];
  required?: boolean;
};

export type FormData = Record<string, string | number | boolean | Date | undefined>;
